import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { Modal, IonIcon, Button } from 'controls'
import BrokerNoteForm from 'components/Forms/BrokerNote/ConnectedBrokerNote'

class AddNote extends Component {
  render() {
    const { isAddingNote, lead, onClose } = this.props

    return (
      <Modal
        isOpen={isAddingNote}
        onClose={onClose}
        width="100%"
        maxWidth="540px"
        coverOnMobile
      >
        <BrokerNoteForm leadId={lead.id} closeModal={onClose}/>
      </Modal>
    )
  }
}

export default AddNote

